import React, { ReactElement } from "react";

import { Col, Icon, Link, Row, Tooltip } from "components";

export type AdminHeadProps = {
  headline: string | ReactElement;
  description?: ReactElement | string;
  title?: string;
  extra?: ReactElement;
  tooltipText?: string;
  link?: string;
  className?: string;
};

export const AdminHead = ({ headline, title, description, link, extra, tooltipText, className = "" }: AdminHeadProps) => (
  <Row justify="space-around" align="middle" className={className}>
    <Col sm={24} md={extra ? 12 : 24}>
      <h2 style={{ margin: "0 0 1rem 0" }}>
        {link && (
          <Link to={link}>
            <Tooltip placement="right" title={tooltipText || ""}>
              <Icon iconName="tabler/arrow-left" className="icon margin-right-50 inline" size="m" style={{ transform: "translate3d(0, -0.25rem, 0)" }} />
            </Tooltip>
          </Link>
        )}
        {headline || title}
      </h2>
      {description && (
        <p style={{ maxWidth: extra ? "768px" : "" }} className="grey-text">
          {description}
        </p>
      )}
    </Col>
    <Col sm={24} md={12} className="right">
      <div className="admin-extra">{extra}</div>
    </Col>
  </Row>
);

export default AdminHead;
